/** Seat limits for an account table (2–9 players, as the form always allowed). */
export const MIN_PLAYERS = 2;
export const MAX_PLAYERS = 9;

export const clampPlayers = (n: number) =>
  Math.min(MAX_PLAYERS, Math.max(MIN_PLAYERS, Math.round(n)));
